import React from "react";
import SortlistedCandidates from "../sortlistedCandidates";
import { constants } from "../../../../constants/common";
const SalaryRound = () => {
    return <SortlistedCandidates level={constants.PROFILE_STATUS.SALARY_DISCUSSION} />
}

export default SalaryRound;